"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldShowImmediateOption = exports.getSelectTimeSlotLabel = exports.shouldShowDrinkLimitOverlay = exports.isFeatureEnabled = void 0;
const constants_1 = require("../constants");
const destinationUtils = require("./destination");
const date_fns_1 = require("date-fns");
const isFeatureEnabled = (venue, feature) => {
    return venue.features.includes(feature);
};
exports.isFeatureEnabled = isFeatureEnabled;
const shouldShowDrinkLimitOverlay = (venue, order, extraCartItem) => {
    const hasAccepted = order ? order.acceptedDrinkLimit : false;
    if (!venue.config.drinkUnitLimitPerPerson || hasAccepted) {
        return false;
    }
    const extra = extraCartItem ? [extraCartItem] : [];
    const newCart = order ? order.cart.concat(extra) : extra;
    const cartServings = newCart.reduce((accum, item) => accum + item.item.alcoholServings * item.quantity, 0);
    return venue.config.drinkUnitLimitPerPerson < cartServings;
};
exports.shouldShowDrinkLimitOverlay = shouldShowDrinkLimitOverlay;
const getSelectTimeSlotLabel = (order) => {
    if (destinationUtils.isDestinationDelivery(order.destination)) {
        return constants_1.constants.PickupTimes.selectADeliveryTime;
    }
    else {
        return constants_1.constants.PickupTimes.selectAPickupTime;
    }
};
exports.getSelectTimeSlotLabel = getSelectTimeSlotLabel;
const shouldShowImmediateOption = (fulfillmentCenter, forDate) => {
    return fulfillmentCenter.allowImmediateOrders && (forDate ? (0, date_fns_1.isToday)(forDate) : true);
};
exports.shouldShowImmediateOption = shouldShowImmediateOption;
//# sourceMappingURL=venue.js.map